import heading from './heading.js';
import text from './text.js';
import label from './label.js';
var textStyles = {
  heading: heading,
  text: text,
  label: label
};
export { textStyles as default };